<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_3"><em>To Kim, look how we turned out!</em></a></p><a id="page_3">
<p class="image"><img alt="Image" src="images/3.jpg"/></p>
</a><p class="image"><a id="page_3"><img alt="Image" src="images/4.jpg"/></a><a id="page_4"></a></p><a id="page_4">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Dedication.vue?12353a99